<template>
  <div class="koc-default-collection-item-magazine">
    <div
      v-if="state.showOverlay"
      class="koc-default-collection-item-magazine-overlay"
      @mouseover="state.showOverLayText = true"
      @mouseleave="state.showOverLayText = false"
    >
      <div class="koc-default-collection-item-magazine-overlay-tooltip">
        <Transition name="slide-fade">
          <div
            v-if="state.showOverLayText"
            class="koc-default-collection-item-magazine-overlay-tooltip"
          >
            <div class="koc-default-collection-item-magazine-overlay-tooltip-container koc-title koc-montserrat">
              <div v-if="state.isVipContent">
                This publication is only available for our VIP level members. Click <a href="https://kelbyone.com/vip">here</a> to learn more
              </div>
              <div v-else>
                This publication is only available for our Pro level members. Click <a href="https://members.kelbyone.com/upgrade">here</a> to upgrade your membership
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <div class="koc-default-collection-item-magazine-image">
      <a :href="item.viewer"><div
        ref="image"
        class="koc-default-collection-item-magazine-image-thumbnail track track-view"
        :style="`background-image: url(${state.imageUrl})`"
      /></a>
    </div>
    <div
      ref="body"
      class="koc-default-collection-item-magazine-content"
    >
      <div class="koc-default-collection-item-magazine-content-title">
        <a
          ref="title"
          class="koc-title koc-montserrat track track-view"
          :href="item.viewer"
        ><span v-html="item.article.title" /></a><br>
        <span v-html="item.title" />
      </div>
      <div class="koc-default-collection-item-magazine-content-body">
        <p v-html="state.excerpt" />
      </div>
      <div class="koc-default-collection-item-magazine-content-footer">
        <div class="koc-default-collection-item-magazine-content-footer-link">
          <a
            ref="view"
            class="koc-title koc-montserrat track track-view"
            :href="item.viewer"
          >VIEW ONLINE</a><br>
        </div>
        <div class="koc-default-collection-item-magazine-content-footer-icons">
          <tooltip
            text="Tutorial Files"
          >
            <button
              ref="files"
              class="koc-button koc-ripple koc-clear koc-small koc-text track track-files"
              @click="toggleModal(item)"
            >
              <font-awesome-icon
                :icon="['fa', 'file-lines']"
                class="magazine-icon"
              />
            </button>
          </tooltip>
          <tooltip
            text="Download PDF"
            :last="true"
            class="koc-member-dashboard-tooltip"
          >
            <a
              ref="download"
              :href="item.pdf"
              class="track track-download"
            >
              <button
                class="koc-button koc-ripple koc-clear koc-small koc-text"
              >
                <font-awesome-icon
                  :icon="['fa', 'file-pdf']"
                  class="magazine-icon"
                />
              </button>
            </a>
          </tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./magazine.js"></script>
<style lang="scss" scoped src="./magazine.scss"></style>
